import { render, staticRenderFns } from "./FCSwiperThumbs.vue?vue&type=template&id=2024470d&scoped=true&"
import script from "./FCSwiperThumbs.vue?vue&type=script&lang=ts&"
export * from "./FCSwiperThumbs.vue?vue&type=script&lang=ts&"
import style0 from "./FCSwiperThumbs.vue?vue&type=style&index=0&id=2024470d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2024470d",
  null
  
)

export default component.exports